module.exports = __webpack_public_path__ + "static/Vedanta_Limited_TTR_2019-9c933624b8a5bc5fe770338c5d9bd61d.pdf";